/**
 * ——————————————————————————————
 * FUNCTION DEFINITIONS / GLOBALS
 * ——————————————————————————————
 */

// Toast notification. Optional `href`: clicking the toast navigates there.
function showToast(content, location, duration = 2500, href = null) {
  const toast = document.createElement("div");
  toast.classList.add("toast");
  toast.textContent = content;

  toast.classList.add(`toast-${location}`);
  document.body.appendChild(toast);
  if (href) toast.addEventListener("click", () => (window.location = href));
  setTimeout(() => {
    toast.classList.add("toast--active");
  }, 10);

  setTimeout(() => {
    toast.classList.remove("toast--active");
    toast.addEventListener(
      "transitionend",
      () => {
        toast.remove();
      },
      { once: true }
    );
  }, duration);
}

const isWishlistPage =
  window.location.pathname.replace("/pages/", "") === "wishlist";

const isProductPage = window.theme.template === "product";
const isCollection = window.theme.template === "collection";

const triggerWishlistRequest = (fn) => {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(fn);
};

const addToWishList = (product) =>
  new Promise((resolve, reject) => {
    triggerWishlistRequest(() =>
      window._swat.addToWishList(
        product,
        (response) => {
          resolve(response);
        },
        (error) => {
          window.console.log({ error });
          reject(error);
        }
      )
    );
  });

const removeFromWishList = (product) =>
  new Promise((resolve, reject) => {
    triggerWishlistRequest(() =>
      window._swat.removeFromWishList(
        product,
        (response) => {
          resolve(response);
        },
        (error) => {
          window.console.log({ error });
          reject(error);
        }
      )
    );
  });

/**
 * We fetch all wishlist items and filter out setting only based checking if they have the cprops.stock_no property.
 */
const fetchItems = () =>
  new Promise((resolve) =>
    triggerWishlistRequest(() =>
      window._swat.fetch((items) =>
        resolve(items.filter((wishlistItem) => !wishlistItem?.cprops?.stock_no))
      )
    )
  );

const hydrateWishlistTrigger = (triggerElement, selectedVariantId = null) => {
  if (!selectedVariantId || !triggerElement) return;
  triggerElement.dataset.wishlistProductVariant = Number(selectedVariantId);
};

const hydrateLocalizedWishlist = async () => {
  const headerWishlistIcon = document.querySelector(".header--wishlist__icon");
  const wishlistItems = await fetchItems();
  window.wishlistItems = wishlistItems;
  window.wishlistItems.length > 0
    ? headerWishlistIcon.setAttribute("data-wishlisted", "true")
    : headerWishlistIcon.removeAttribute("data-wishlisted");

  const wishlistTriggers = [
    ...document.querySelectorAll("[data-add-to-wishlist]"),
  ];

  wishlistTriggers.forEach((trigger) => {
    const triggerVariant = Number(trigger.dataset.wishlistProductVariant);
    const foundItem = window.wishlistItems.find(
      (item) => item.epi === triggerVariant
    );
    foundItem
      ? trigger.setAttribute("data-wishlisted", "true")
      : trigger.removeAttribute("data-wishlisted");
  });

  updateWishlistCounter();

  return wishlistItems;
};

updateWishlistCounter = (count) => {
  const wishlistCount = document.querySelector(".wishlist__count");
  const wishlistCountInner = document.querySelector(".wishlist__count span");
  if (!wishlistCount || !wishlistCountInner) {
    return;
  }
  if (window.wishlistItems.length < 1 || count === 0) {
    wishlistCount.classList.remove("active");
    return;
  }
  if (count) {
    wishlistCountInner.innerText = String(count);
  } else {
    wishlistCountInner.innerText = String(window.wishlistItems.length);
  }
  wishlistCount.classList.add("active");
};

const handleWishlistTriggerClick = async (trigger) => {
  const isWishlisted = Boolean(trigger.dataset.wishlisted);
  const item = {
    epi: Number(trigger.dataset.wishlistProductVariant),
    empi: Number(trigger.dataset.wishlistProductId),
    du: window.location.origin + trigger.dataset.wishlistProductUrl,
    pr: trigger.dataset.wishlistProductPrice,
  };

  if (isWishlisted) {
    const removeResponse = await removeFromWishList(item);
    if (removeResponse.ok === false) {
      throw new Error("Removing item from wishlist failed...");
    }
    trigger.removeAttribute("data-wishlisted");
    showToast("Removed from wishlist.", "bottom", 2500, "/pages/wishlist");
  } else {
    const addResponse = await addToWishList(item);
    if (addResponse.ok === false) {
      throw new Error("Adding item to wishlist failed...");
    }
    trigger.setAttribute("data-wishlisted", "true");
    showToast("Added to wishlist!", "bottom", 2500, "/pages/wishlist");
  }

  await hydrateLocalizedWishlist();

  updateWishlistCounter();
};

window.wishlistFunctions = window.wishlistFunctions || {};
window.wishlistFunctions.hydrateLocalizedWishlist = hydrateLocalizedWishlist;
window.wishlistFunctions.handleWishlistTriggerClick =
  handleWishlistTriggerClick;

/**
 * ——————————————————————————————
 * FUNCTION EXECUTION (DOM READY)
 * ——————————————————————————————
 */

window.addEventListener("DOMContentLoaded", async () => {
  await hydrateLocalizedWishlist();

  updateWishlistCounter();

  const rootUrl =
    window.theme.locale && window.theme.locale.primary
      ? ""
      : window.theme.locale.rootUrl;

  // Attentive renders the BIS button as <button>TEXT</button> with no
  // inner span. Wrap the text in <span class="btn__text"> so the theme's
  // button text-alignment styles apply (matches the convention used by
  // other theme buttons). Attentive swaps textContent when signup state
  // changes (enabled ↔ disabled), so observe and re-wrap as needed.
  const wrapBisButtonText = () => {
    const btn = document.getElementById("attn-waitlist-trigger-btn");
    if (!btn || btn.querySelector(".btn__text")) return;
    const text = btn.textContent.trim();
    if (!text) return;
    btn.textContent = "";
    const span = document.createElement("span");
    span.className = "btn__text";
    span.textContent = text;
    btn.appendChild(span);
  };
  const bisTrigger = document.getElementById("attn-waitlist-trigger");
  if (bisTrigger) {
    wrapBisButtonText();
    new MutationObserver(wrapBisButtonText).observe(bisTrigger, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  // A third-party script (originating from selectors.js / index.js —
  // exact source not confirmed) replaces the cart count with
  // <span class="cart-link__count">N</span>, missing the inner <span>
  // the theme's styles expect. Wrap the text node in a <span> so
  // .cart-link__count span styles apply.
  const wrapCartCountText = (el) => {
    if (
      !el ||
      el.nodeType !== 1 ||
      !el.matches?.(".cart-link__count") ||
      el.querySelector("span")
    ) {
      return;
    }
    const text = el.textContent.trim();
    if (!text) return;
    el.textContent = "";
    const inner = document.createElement("span");
    inner.textContent = text;
    el.appendChild(inner);
  };

  // theme:cartchanged (public/theme.js) triggers an async
  // ?sections=header refresh that replaces the inner HTML of the
  // header right-area, wiping JS-applied wishlist state and dropping
  // any cart-count wrapping. Watch the area for any DOM change and
  // re-apply both. Cooldown prevents recursion from our own writes.
  const headerArea = document.querySelector(
    "#pageheader .logo-area__right__inner"
  );
  if (headerArea) {
    let cooldownUntil = 0;
    const refreshHeaderState = () => {
      headerArea
        .querySelectorAll(".cart-link__count")
        .forEach(wrapCartCountText);
      if (!window.wishlistItems) return;
      const headerIcon = headerArea.querySelector(".header--wishlist__icon");
      if (!headerIcon) return;
      if (window.wishlistItems.length > 0) {
        headerIcon.setAttribute("data-wishlisted", "true");
      } else {
        headerIcon.removeAttribute("data-wishlisted");
      }
      updateWishlistCounter();
    };

    // Run once on init in case anything is already malformed.
    refreshHeaderState();

    new MutationObserver(() => {
      if (performance.now() < cooldownUntil) return;
      cooldownUntil = performance.now() + 100;
      refreshHeaderState();
    }).observe(headerArea, { childList: true, subtree: true });
  }

  if (isProductPage) {
    const wishlistTrigger = document.querySelector("[data-add-to-wishlist]");
    const wishlistTriggers = [
      ...document.querySelectorAll("[data-add-to-wishlist]"),
    ];
    const options = document.querySelector(".original-selector");

    if (options) {
      options.addEventListener("change", () => {
        const selectedVariantId = Number(options.selectedOptions[0].value);
        const isWishlisted = window.wishlistItems.find(
          (item) => item.epi === selectedVariantId
        );
        wishlistTriggers.forEach((trigger) => {
          hydrateWishlistTrigger(trigger, selectedVariantId);
          isWishlisted
            ? trigger.setAttribute("data-wishlisted", "true")
            : trigger.removeAttribute("data-wishlisted");
        });
      });
    }

    wishlistTriggers.forEach((trigger) => {
      trigger.addEventListener("click", async (evt) => {
        evt.preventDefault();
        await handleWishlistTriggerClick(trigger);
      });
    });
  } else if (isWishlistPage) {
    const gridWrapper = document.querySelector(".wishlist-container");

    gridWrapper.dataset.itemCount = Number(window.wishlistItems.length);

    const itemsLoopPromises = window.wishlistItems.map(async (item) => {
      const handle = item.du.split("products/")[1];
      const url = `${rootUrl}/products/${handle}?view=wishlist&variant=${item.epi}`;
      const response = await fetch(url);
      const itemsWrapper = gridWrapper.querySelector(".wishlist__items");

      if (response.ok === false) {
        throw new Error("Wishlist items response was not ok");
      }

      const data = await response.text();

      if (itemsWrapper) {
        itemsWrapper.insertAdjacentHTML("beforeend", data);
        const wishlistTriggers = [
          ...document.querySelectorAll("[data-add-to-wishlist]"),
        ];
        wishlistTriggers.forEach((trigger) =>
          trigger.setAttribute("data-wishlisted", "true")
        );
      }

      return data;
    });

    // Wait for all items to be fetched and inserted into the DOM
    await Promise.all(itemsLoopPromises);

    const removeTriggers = gridWrapper.querySelectorAll(".wishlist__remove");
    theme?.ProductBlockManager?.loadImages();
    theme.applyAjaxToProductForm(gridWrapper, true);

    $(".show-12-more").click(function () {
      $(this).parent().toggleClass("result_hover");
    });

    // Handle Wishlist item removal
    gridWrapper.addEventListener("click", async (evt) => {
      const target = evt.target;

      if (
        !target?.attributes["data-remove-from-wishlist"] &&
        !target?.attributes["data-add-to-wishlist"]
      )
        return;

      evt.preventDefault();

      const parent = target.closest("form");
      const id = Number(target?.dataset.wishlistProductVariant);
      const item = window.wishlistItems.find((item) => item.epi === id);
      const removeResponse = await removeFromWishList(item);
      const headerWishlistIcon = document.querySelector(
        ".header--wishlist__icon"
      );
      if (removeResponse.ok === false) {
        throw new Error("Removing item from wishlist failed...");
      }
      parent.remove();
      const updatedCount = Number(gridWrapper.dataset.itemCount) - 1;
      updateWishlistCounter(updatedCount);
      gridWrapper.dataset.itemCount = updatedCount;
      if (updatedCount === 0) {
        headerWishlistIcon.removeAttribute("data-wishlisted");
      }
    });

    document.addEventListener("wishlist-item-added-to-cart", (evt) => {
      const urlParams = new URLSearchParams(evt.detail.formData);
      const addedVariantId = Number(urlParams.get("id"));
      removeTriggers.forEach((trigger) => {
        const triggerVariantId = Number(trigger.dataset.wishlistProductVariant);
        if (Number(triggerVariantId) === addedVariantId) {
          trigger.click();
        }
      });
    });
  } else {
    // Assume trigger comes from a 'product-block' which is rendered to collection or homepage sections
    const wishlistTriggers = [
      ...document.querySelectorAll("[data-add-to-wishlist]"),
    ];

    wishlistTriggers.forEach((trigger) =>
      trigger.addEventListener("click", async (evt) => {
        evt.preventDefault();
        await handleWishlistTriggerClick(trigger);
      })
    );
  }
});
